import React, { useEffect, useRef, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import "./PublicLayout.css";

const STAFF_LOGINS = [
  { to: "/admin/login", label: "Super Admin / Tower Admin" },
  { to: "/fms/login", label: "FMS" },
  { to: "/gate/login", label: "Gate Staff" },
];

export default function PublicLayout() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [loginMenuOpen, setLoginMenuOpen] = useState(false);
  const loginMenuRef = useRef(null);
  const isActive = (path) => location.pathname === path;
  const isStaffLoginActive = STAFF_LOGINS.some((l) => isActive(l.to));

  const closeMenu = () => setMenuOpen(false);

  // Close the desktop login dropdown on outside click or Escape.
  useEffect(() => {
    if (!loginMenuOpen) return undefined;
    const onClick = (e) => {
      if (loginMenuRef.current && !loginMenuRef.current.contains(e.target)) {
        setLoginMenuOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") setLoginMenuOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [loginMenuOpen]);

  return (
    <div className="public-shell">

      {/* Premium Header */}
      <header className="public-navbar">
        <div className="public-logo">Crown Residences</div>

        <button
          className="public-menu-toggle hide-desktop"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`public-nav ${menuOpen ? "open" : ""}`}>
          <Link className={isActive("/") ? "nav-link active" : "nav-link"} to="/" onClick={closeMenu}>Home</Link>
          <Link className={isActive("/facilities") ? "nav-link active" : "nav-link"} to="/facilities" onClick={closeMenu}>Facilities</Link>
          <Link className={isActive("/rentals") ? "nav-link active" : "nav-link"} to="/rentals" onClick={closeMenu}>Rentals</Link>
          <Link className={isActive("/rules") ? "nav-link active" : "nav-link"} to="/rules" onClick={closeMenu}>Rules</Link>
          <Link className={isActive("/downloads") ? "nav-link active" : "nav-link"} to="/downloads" onClick={closeMenu}>Downloads</Link>
          <Link className={isActive("/contact") ? "nav-link active" : "nav-link"} to="/contact" onClick={closeMenu}>Contact</Link>

          <div className="public-actions-mobile hide-desktop">
            <Link className="login-link login-link-primary" to="/resident/login" onClick={closeMenu}>
              Resident Login
            </Link>
            <span className="staff-login-label">Staff login</span>
            {STAFF_LOGINS.map((l) => (
              <Link key={l.to} className="staff-login-link" to={l.to} onClick={closeMenu}>
                {l.label}
              </Link>
            ))}
          </div>
        </nav>

        <div className="public-actions hide-mobile">
          <Link className={isActive("/resident/login") ? "login-link login-link-primary active" : "login-link login-link-primary"} to="/resident/login">
            Resident Login
          </Link>

          <div className="staff-login-menu" ref={loginMenuRef}>
            <button
              type="button"
              className={isStaffLoginActive ? "staff-login-toggle active" : "staff-login-toggle"}
              onClick={() => setLoginMenuOpen((v) => !v)}
              aria-haspopup="true"
              aria-expanded={loginMenuOpen}
            >
              Staff Login
              <svg className="staff-login-caret" viewBox="0 0 12 8" width="10" height="7" aria-hidden="true">
                <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            {loginMenuOpen && (
              <div className="staff-login-dropdown" role="menu">
                {STAFF_LOGINS.map((l) => (
                  <Link
                    key={l.to}
                    className={isActive(l.to) ? "staff-login-dropdown-link active" : "staff-login-dropdown-link"}
                    to={l.to}
                    role="menuitem"
                    onClick={() => setLoginMenuOpen(false)}
                  >
                    {l.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </header>

      {menuOpen && <div className="public-menu-backdrop hide-desktop" onClick={closeMenu} />}

      {/* Page Content */}
      <main className="public-content">
        <Outlet />
      </main>

      {/* Clean Footer */}
      <footer className="public-footer">
        <div className="footer-brand">Crown Residences Association</div>
        <div className="footer-contact">
          Emergency: +91‑00000‑00000 • helpdesk@crownresidence.in
        </div>
        <div className="footer-copy">
          © {new Date().getFullYear()} Crown Residences. All rights reserved.
        </div>
      </footer>

    </div>
  );
}